import { ServiceCard } from './ServiceCard';
import { services } from '../../data/mock';

export const ServicesSection = ({ handleWhatsAppClick }) => (
<section id="services" className="py-12 md:py-16 bg-gradient-to-b from-gray-950 to-black relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-5">
          <img 
            src="https://images.unsplash.com/photo-1707248592051-4be0ecc8c204" 
            alt="Rituels Spirituels Marabout Africain - Magie Blanche Rouge Noire" 
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-8 md:mb-12 px-4">
            <span className="inline-block bg-red-600/20 border border-red-600/40 text-red-400 px-4 md:px-6 py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6">
              Services du Grand Marabout Sorcier Vaudou
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-red-600">Rituels et Services Spirituels</h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Le grand marabout sorcier vaudou Maître Diamma met ses puissants pouvoirs ancestraux 
              et son expertise de plus de 20 ans au service de tous vos besoins spirituels.
            </p>
          </div>

          <div className="services-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {services.map((service) => (
                <ServiceCard key={service.id} service={service} handleWhatsAppClick={handleWhatsAppClick} />
            ))}
          </div>
        </div>
      </section>
);
